// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "module." + {"979":"swiper","995":"focus-trap"}[chunkId] + ".js?v=" + {"979":"4059e13c7b95fa961436","995":"55b0595a984bfa68f224"}[chunkId] + "";
};